import React, { useState, useEffect, useContext, Component,useRef, useCallback } from 'react';
import { useBlogContext } from '../../fetchdata/BlogContext';
import { Link, useNavigate, useSearchParams ,useLocation } from 'react-router-dom';
import axios from 'axios';
import axiosInstance, { weburl } from '../../axiosInstance';
import { Helmet } from 'react-helmet';
import Select from 'react-select'; // Import react-select
import toast from 'react-hot-toast';
import GooglePlaceSelect from '../components/GooglePlaceSelect';
import Header from '../components/Header';
import Footer from '../components/Footer';
import getDecryptData from '../../helper/getDecryptData';

const FindListing = () => {
 
  const [searchParams] = useSearchParams();
  const cat = searchParams.get("cat");


const [showAllOffers, setShowAllOffers] = useState(null);


// const [filterInputs, setFilterInputs] = React.useState({
//   location: "",
//   placeId: "",
// });

const handleLocationChange = (selected) => {
  console.log('myselected',selected)

    setFilterInputs((prevData) => ({
          ...prevData,
        location: selected?.label || "",
    placeId: selected?.value || "",
    state: selected?.state || "",
    city: selected?.city || "",
    label: selected?.label || "",
    lat: selected?.lat || "",
    lng: selected?.lng || "",
        }));

  // setFilterInputs({
  //   location: selected?.label || "",
  //   placeId: selected?.value || "",
  //   state: selected?.state || "",
  //   city: selected?.city || "",
  //   label: selected?.label || "",
  //   lat: selected?.lat || "",
  //   lng: selected?.lng || "",
  //   department: cat || null
  // });
};

const [isFetchingMore, setIsFetchingMore] = useState(false);

const [lastLoading, setLastLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setlimit] = useState(50);

    
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

    const handleShowMore = () => {
    // Update the skip value to fetch the next set of leads
    setCurrentPage((prevSkip) => prevSkip + limit);
    setLastLoading(true);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();


  const initialFilterData = {
  location: "",
  placeId: "",
  Experience: null,
  department: cat || null
  };

  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);

  const [filteredCities, setFilteredCities] = useState([]);


 

  
  const [filterInputs, setFilterInputs] = useState(initialFilterData);
  const [doctorList, setDoctorList] = useState([]);
  const [loading, setLoading] = useState(false);

    // Handle change in the search filters
   
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files[0];
    } else {
      newValue = value;
    }

    // Capitalize text for the 'username' field
    if (name === "state") {
      const selectedState = data.find((state) => state._id === newValue);
      if (selectedState) {
        setFilteredCities(selectedState.cities);
        setFilterInputs((prevData) => ({
          ...prevData,
          statename: selectedState.name,
          city: "",
        }));
      }
      console.log("selectedState", selectedState, newValue, data);
    }

    setFilterInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };


     
       const handleClearClick = () => {
      
      };
    

 
        const decryptdatajson = getDecryptData();
    
        const userId = decryptdatajson?._id;

  const searchDoctors = async () => {
     
    if(currentPage === 1){
    setLoading(true);
    }else{
      setIsFetchingMore(true);
    }


    console.log('find-listing',filterInputs)
 
       const finalData = {
      state: filterInputs.state || "",
      city: filterInputs.city || "",
      department: filterInputs.department ||  "",
      page:  filterInputs.currentPage || currentPage,
       limit:  filterInputs.limit || limit, 
        lat:  filterInputs.lat || '', 
        lng:  filterInputs.lng || '', 
        // Experience:  filterInputs.Experience || '', 
        Distance:  filterInputs.Distance || '', 
        // Consultation:  filterInputs.Consultation || '', 
        userId: userId || '', 
         subDepartment: filterInputs.subDepartment || '',
    };
     
    try {
    const response = await axiosInstance.get("get-all-listing", {
    params: finalData
  });
  console.log('responseresponseresponseresponseresponse',response.data)
 if (currentPage === 1) {
    setDoctorList(response.data.friends);
  } else {
    setDoctorList((prev) => [...prev, ...response.data.friends]);
  }
  
  setData2(response.data.allSubDepartments??[]);
  setTotalPages(response.data.totalPages ?? 1);

    } catch (error) {
      // toast.error("Failed to fetch doctors, please try again.");
      console.error(error);
      setDoctorList([]); // Assuming the API returns a list of doctors
    } finally {
      setLoading(false);
      setIsFetchingMore(false);

    }
  };

// 1. Reset page to 1 when filters change
useEffect(() => {
  // Only reset if currentPage is not already 1
  if (currentPage !== 1) {
    setCurrentPage(1);
  } else {
    // If already 1, fetch immediately
    searchDoctors();
  }
}, [
  filterInputs.city,
  filterInputs.Distance,
  // filterInputs.Consultation,
  // filterInputs.Experience,
  filterInputs.state,
  filterInputs.department,
  filterInputs.subDepartment,
  filterInputs.lat,
  filterInputs.lng,
  location.search,
]);

// 2. Fetch data when currentPage changes
useEffect(() => {
  // Only fetch if page is changed programmatically
  if (currentPage !== 1) {
    searchDoctors();
  }
}, [currentPage]);


  const [department, setDepartment] = useState([]);


  const getDepartment = async () => {
  try {
      const { data } = await axiosInstance.get(`/get-all-department`);
      const { success,  Department, message } = data;
      if(success){
      setDepartment(Department ?? []);
      }
      

      console.log('Department',Department)
      // Delay the execution of buildScript by 1 secon
    }
    catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } 
  }

useEffect(() => {
 getDepartment();
 
}, []);

useEffect(() => {
 
   if(cat){
    console.log('catcatcatcat',cat);
     setFilterInputs((prevData) => ({
          ...prevData,
          department: cat, 
        }));
  }

}, [cat]);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }


  const observer = useRef();

const lastCardRef = useCallback(
  (node) => {
    if (loading || isFetchingMore) return;

    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && currentPage < totalPages) {
        setCurrentPage((prev) => prev + 1);
      }
    });

    if (node) observer.current.observe(node);
  },
  [loading, isFetchingMore, currentPage, totalPages]
);

 

  const sendFriend = async (recId) => {


    const finalData = {
      senderId: userId,
      receiverId : recId
    }
    setLoading(true);
    try {
      const  {data}   = await axiosInstance.post(`/send-request`,finalData);
  
         console.log('datadata',data)

      const {success} = data;
      if(success){
      toast.success('Add connection successfully');

       } 
      // Delay the execution of buildScript by 1 secon
    }
    catch (error) {
      console.log(error);
    toast.error(error.response.data.message ?? 'Getting error');
    } finally {
       setLoading(false);
      searchDoctors();
    }
 
  };

   const cancelFriend = async (recId) => {


    const finalData = {
      senderId: recId,
      receiverId : userId
    }
    setLoading(true);
    try {
      const  {data}   = await axiosInstance.post(`/reject-request`,finalData);
  
 
      const {success} = data;
     console.log('datadata',data)

      if(success){
      toast.success('Cancel connection successfully');

       } 
      // Delay the execution of buildScript by 1 secon
    }
    catch (error) {
      console.log(error);
    toast.error(error.response.data.message ?? 'Getting error');
    } finally {
       setLoading(false);
      searchDoctors();
    }
 
  };

const departmentOptions = department.map(dep => ({
  label: dep.name,
  value: dep._id,
}));

// Find selected department object
const selectedDepartment = department.find(
  dep => dep._id === filterInputs.department
);

// Build subdepartment options from selected department
const subDepartmentOptions = selectedDepartment
  ? selectedDepartment.value.map(sub => ({
      label: sub,
      value: sub,
    }))
  : [];


  return (
    <>
      <Header />

      <Helmet>
        <title> All Vendors | {window.location.hostname}</title>
      </Helmet>
 
  {/* <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>State</th>
          <th>City</th>
          <th>Latitude</th>
          <th>Longitude</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{filterInputs.state || 'NA STATE'}</td>
          <td>{filterInputs.city || 'NA city'}</td>
          <td>{filterInputs.lat || 'NA lat'}</td>
          <td>{filterInputs.lng || 'NA lng'}</td>
        </tr>
      </tbody>
    </table> */}

            
<div className="bg-light d-none">

      <div className="container pt-4 pb-2">
          <div className="search-header row justify-content-center px-3 " >
            <div className="d-flex mb-3 border px-2 col-md-3 bg-white">
              <span className="p-3 px-0" id="inputGroup-sizing-default">
                <i className="ri-map-pin-line"></i>
              </span>
          
              {/* <input
                type="search"
                className="form-control border-0 shadow-none"
                placeholder="Search Location"
                name="location"
                value={filterInputs.location}
                onChange={handleChange}
              /> */}

{/*               
    <select   className="form-control border-0 shadow-none"
                      id="state"
                      name="state"
                      value={loading ? '': filterInputs.state }
                      onChange={handleChange}
                    >
                      <option  >
                      Select State
                         {loading ? "Loading..." : "Select State"}  
                      </option>
                      {data.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      ))}{" "}
                      ;
    </select> */}
                    
            
                    {/* <Select
        className='border-0 w-100 custom-none-border'
        id="department"
        name="department"
        options={data.map(item => ({
          label: item.name,  // Option label (text)
          value: item._id,   // Option value (ID)
        }))}
        value={data.find(item => item._id === filterInputs.state)  // Find the selected state
          ? {
              label: data.find(item => item._id === filterInputs.state).name,  // Display name of the state
              value: data.find(item => item._id === filterInputs.state)._id,   // Use the state's ID as value
            }
          : null
        }
        onChange={(selectedOption) => handleChange({
          target: { name: "state", value: selectedOption?.value || "" }
        })}
        isClearable  // Optionally add a clear button
        placeholder={loading ? "Loading..." : "Select State"}
      /> */}

      
<GooglePlaceSelect
  className="border-0 w-100 custom-none-border"
  value={
    filterInputs?.placeId
      ? {
          label: filterInputs?.location,
          value: filterInputs?.placeId,
          city: filterInputs?.city,
          state: filterInputs?.state,
          lat: filterInputs?.latitude,
          lng: filterInputs?.longitude,
        }
      : null
  }
  onChange={handleLocationChange}
/>


            </div>

            <div className="d-flex mb-3 border px-2 col-md-3 bg-white ">
              <span className="p-3 px-0" id="inputGroup-sizing-default">
                <i className="ri-search-line"></i>
              </span>
              
              {/* <input
                type="search"
                className="form-control border-0 shadow-none"
                placeholder="Search Specialty"
                name="specialty"
                value={filterInputs.specialty}
                onChange={handleChange}
              /> */}
 
<Select
className='border-0 w-100 custom-none-border'
        id="city"
        name="city"
        options={filteredCities.map(city => ({
          label: city,
          value: city,
        }))}
        value={filteredCities.some(city => city === filterInputs.city) 
          ? { label: filterInputs.city, value: filterInputs.city } 
          : null
        } 
         onChange={(selectedOption) => handleChange({ target: { name: "city", value: selectedOption?.value || "" } })}
        isClearable // Optionally add a 
        // clear button
        placeholder={loading ? "Loading..." : "Select City"}
      />

{/* <select  className="form-control border-0 shadow-none"
                      id="city"
                      name="city"
                      value={filterInputs.city}
                      onChange={handleChange}
                    >
                      <option selected value={""}>
                        {" "}
                        {loading ? "Loading..." : "Select City"}
                      </option>
                      {filteredCities.map((city, index) => (
                        <option key={index} value={city}>
                          {city}
                        </option>
                      ))}{" "}
                      ;
                    </select> */}

                    

            </div>

            <div className="d-flex mb-3 border px-2 col-md-3 bg-white ">
              <span className="p-3 px-0" id="inputGroup-sizing-default">
                <i className="ri-search-line"></i>
              </span>
              <Select
  className="border-0 w-100 custom-none-border"
  id="department"
  name="department"
  options={data2.map(item => ({
    label: item,  // Option label (text)
    value: item,   // Option value (ID)
  }))}
  value={data2.find(item => item._id === filterInputs.department)  // Find the selected state
    ? {
        label: data2.find(item => item._id === filterInputs.department).name,  // Display name of the state
        value: data2.find(item => item._id === filterInputs.department)._id,   // Use the state's ID as value
      }
    : null
  }
  onChange={(selectedOption) => handleChange({
    target: { name: "department", value: selectedOption?.value || "" }
  })}
  isClearable  // Optionally add a clear button
  placeholder={loading ? "Loading..." : "Select Category"}  // Change placeholder text to be more relevant
/>


              </div>

            <div className="d-flex mb-3 col-md-2 px-0 ">
              <button
                className="btn btn-dark btn-shadow d-block w-100 rounded-0"
                onClick={handleClearClick} // Trigger the search when the button is clicked
              >
                Clear
              </button>
            </div>
          </div>
          </div>
  
          </div>

<div className="d-flex gap-4 align-items-center px-3 mt-3 d-md-none">

<Link to={'/'} className="btn btn-transparent p-0 fs-2 " type="button">
    <i className="ri-arrow-left-line"/>
</Link>

      <div className='bg-grey border  rounded-pill w-100'>
 <Select
  className="border-0 w-100 custom-none-border text-muted"
  id="department"
  name="department"
  options={departmentOptions}
  value={
    departmentOptions.find(opt => opt.value === filterInputs.department) || null
  }
  onChange={(selectedOption) => {
    // Set department id
    handleChange({
      target: { name: "department", value: selectedOption?.value || "" },
    });
    // Clear subdepartment when department changes
    handleChange({
      target: { name: "subDepartment", value: "" },
    });
  }}
  isClearable
  placeholder={loading ? "Loading..." : "Select Department"}
/>

      </div>
       
    

       {/* <div className="bg-grey border text-muted w-100 py-2 rounded-pill px-3">
       
       </div> */}
  
</div>

  <div className="container py-4">
    <div className='d-none'>
   <h4 className='m-0'>22 Cardiologists available in South delhi, Delhi </h4>  
<p>
    Book appointments with minimum wait-time & verified doctor details
</p>
    </div>
 

 
<div className="d-md-none ">

<div className=" mb-4 ">
 



   <div className="dropdown d-inline-block me-2 mb-2">
  <button
    className={`btn btn-md border rounded-pill py-1 ${filterInputs?.Experience
      ? 'bg-dark text-white'
      : ''}`} 
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
Location <i className="ri-arrow-down-s-line"/>
  </button>
  <div className="dropdown-menu ">
         {/* Location */}
    <div className="mb-0 d-block p-2">
         <label className="fw-semibold mb-1">
      Location
    </label>

    <div className="d-flex mb-3 border px-2 rounded bg-white">
              <span className="p-3 px-0" id="inputGroup-sizing-default">
                <i className="ri-map-pin-line"></i>
              </span>
           
      
<GooglePlaceSelect
className='border-0 w-100 custom-none-border'
  value={
    filterInputs?.placeId
      ? {
          label: filterInputs?.location,
          value: filterInputs?.placeId,
          city: filterInputs?.city,
          state: filterInputs?.state,
          lat: filterInputs?.latitude,
          lng: filterInputs?.longitude,
        }
      : null
  }
  onChange={handleLocationChange}
/> 
            </div>

            
      </div>
  </div>
</div>



   <div className="dropdown d-inline-block me-2 mb-2 d-none">
  <button
    className={`btn btn-md border rounded-pill py-1 ${filterInputs?.Experience
      ? 'bg-dark text-white'
      : ''}`} 
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
Experience <i className="ri-arrow-down-s-line"/>
  </button>
  <div className="dropdown-menu ">
         {/* Experience */}
        <div className="mb-0 d-block p-2">
         <label className="fw-semibold mb-1">
      Experience
    </label> 
         <input
          type="range"
          className="form-range"
          min={1}
          max={20}
          defaultValue={0}
         value={filterInputs.Experience}
         onChange={handleChange}
         name='Experience'
        />
        {filterInputs.Experience && 
         <small className="text-muted">{filterInputs.Experience}+ Years</small>  
        }
 
      </div>
  </div>
</div>

  <div className="dropdown d-inline-block me-2 mb-2 d-none">
  <button
    className={`btn btn-md border rounded-pill py-1 ${filterInputs?.Consultation
      ? 'bg-dark text-white'
      : ''}`} 
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
fees <i className="ri-arrow-down-s-line"/>
  </button>
  <div className="dropdown-menu ">
   
       <div className="mb-0 d-block p-2">
         <label className="fw-semibold mb-1">
      Consultation Fee
    </label>
         <select   onChange={handleChange}
         name='Consultation'  className="form-select">
          <option value={""} >Any</option>
          <option  value="below-300">Below ₹300</option>
          <option value="300-600" >₹300 - ₹600</option>
          <option value="600-800" >₹600 - ₹800</option>
          <option value="800-plus" >₹800+</option>
        </select>
      </div>
  </div>
</div>


   <div className="dropdown d-inline-block me-2 mb-2">
  <button
    className={`btn btn-md border rounded-pill py-1 ${filterInputs?.Distance
      ? 'bg-dark text-white'
      : ''}`} 
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
Distance <i className="ri-arrow-down-s-line"/>
  </button>
  <div className="dropdown-menu ">
      
       <div className="mb-0 d-block p-2">
        <label className="fw-semibold mb-1">
      Distance
    </label>
          <select className="form-select"
         onChange={handleChange}
         name='Distance' >
           <option value={""}>Select Distance</option>
          <option value={2}>Less than 2 kms</option>
          <option value={5}> Less than 5 kms </option>
          <option value={15} > Less than 15 kms </option>
          <option value={0} >Entire city</option>
        </select>
      </div>
  </div>
</div>

</div>



</div>

 


<div className='col-md-12 mx-auto'>


<div className="row">


<div className="col-md-3">

  {/* Sidebar Content */}
  <div id="filterSidebar" className="collapse d-md-block">
    <div
      className="p-4 border rounded shadow-sm bg-white sticky-top"
      style={{ top: 90 }}
    >
      <h5 className="fw-bold mb-3">Filters</h5>
      {/* Location */}
      <div className="mb-3">
        <label className="fw-semibold mb-1">Locations</label>
      
         <div className="d-flex mb-3 border px-2 rounded bg-white">
              <span className="p-3 px-0" id="inputGroup-sizing-default">
                <i className="ri-map-pin-line"></i>
              </span>
           
      
<GooglePlaceSelect
  className="border-0 w-100 custom-none-border"

  value={
    filterInputs?.placeId
      ? {
          label: filterInputs?.location,
          value: filterInputs?.placeId,
          city: filterInputs?.city,
          state: filterInputs?.state,
          lat: filterInputs?.latitude,
          lng: filterInputs?.longitude,
        }
      : null
  }
  onChange={handleLocationChange}
/> 
            </div>

      </div>
      {/* Speciality */}
      <div className="mb-3">
        <label className="fw-semibold mb-1">Category</label>
       
         <div className="d-flex mb-3 border px-2 rounded bg-white">
              <span className="p-3 px-0" id="inputGroup-sizing-default">
                <i className="ri-search-line"></i>
              </span>
<Select
  className="border-0 w-100 custom-none-border text-muted"
  id="department"
  name="department"
  options={departmentOptions}
  value={
    departmentOptions.find(opt => opt.value === filterInputs.department) || null
  }
  onChange={(selectedOption) => {
    // Set department id
    handleChange({
      target: { name: "department", value: selectedOption?.value || "" },
    });
    // Clear subdepartment when department changes
    handleChange({
      target: { name: "subDepartment", value: "" },
    });
  }}
  isClearable
  placeholder={loading ? "Loading..." : "Select Catgeory"}
/>


              </div> 
      </div>

   {/* Speciality */}
      <div className="mb-3">
        <label className="fw-semibold mb-1">Sub Category</label>
       
         <div className="d-flex mb-3 border px-2 rounded bg-white">
              <span className="p-3 px-0" id="inputGroup-sizing-default">
                <i className="ri-search-line"></i>
              </span>
 <Select
  className="border-0 w-100 custom-none-border text-muted"
  id="subDepartment"
  name="subDepartment"
  options={subDepartmentOptions}
  value={
    subDepartmentOptions.find(
      opt => opt.value === filterInputs.subDepartment
    ) || null
  }
  onChange={(selectedOption) =>
    handleChange({
      target: { name: "subDepartment", value: selectedOption?.value || "" },
    })
  }
  isClearable
  placeholder={
    selectedDepartment ? "Select Subdepartment" : "Select Department First"
  }
/>



              </div> 
      </div>

      
      {/* Experience */}
      <div className="mb-3 d-none">
        <label className="fw-semibold mb-1">Experience</label>
        <input
          type="range"
          className="form-range"
          min={1}
          max={20}
          defaultValue={0}
         value={filterInputs.Experience}
         onChange={handleChange}
         name='Experience'
        />
        {filterInputs.Experience && 
         <small className="text-muted">{filterInputs.Experience}+ Years</small>  
        }
 
      </div>
      {/* Fee */}

      <div className="mb-3 d-none">
        <label className="fw-semibold mb-1">Consultation Fee</label>
        <select   onChange={handleChange}
         name='Consultation'  className="form-select">
          <option value={""} >Any</option>
          <option  value="below-300">Below ₹300</option>
          <option value="300-600" >₹300 - ₹600</option>
          <option value="600-800" >₹600 - ₹800</option>
          <option value="800-plus" >₹800+</option>
        </select>
      </div>

  <div className="mb-3">
        <label className="fw-semibold mb-1"> Distance</label>
        <select className="form-select"
         onChange={handleChange}
         name='Distance' >
           <option value={""}>Select Distance</option>
          <option value={2}>Less than 2 kms</option>
          <option value={5}> Less than 5 kms </option>
          <option value={15} > Less than 15 kms </option>
          <option value={0} >Entire city</option>
        </select>
      </div>
  

      {/* <button className="btn btn-primary w-100 mt-2">Apply Filters</button> */}
    </div>
  </div>
  
</div>

        <div className="doctor-list  col-md-9 ">
          <div className='row'>
 
        
            {loading ? (
              <>
                <div className="doctor-card col-md-6">
                  <div className="d-flex border-bottom gap-4 p-4 w-100 rounded shadow-sm">
                    <div className="doctor-profile">
                      <div
                        className="skeleton w-100 rounded-circle"
                        style={{
                          width: "100px",
                          maxWidth: "100%",
                          height: "100px",
                          aspectRatio: "1/1",
                        }}
                      ></div>
                    </div>
                    <div className="doctor-details row align-items-center gap-4 flex-1 w-100">

                      <div className="doctor-details-left flex-1 w-100">
                        <div
                          className="skeleton  "
                          style={{
                            height: "30px",
                            width: "50%",
                          }}
                        />
                        <span
                          className="d-inline-block skeleton mt-3 "
                          style={{
                            height: "25px",
                            width: "70px",
                          }}
                        />{" "}
                        <span
                          className=" d-inline-block  skeleton  mt-3 "
                          style={{
                            height: "25px",
                            width: "50px",
                          }}
                        />{" "}
                        
                       
                      </div>
 
                    </div>
                  </div>
                </div>

                <div className="doctor-card col-md-6">
                  <div className="d-flex border-bottom gap-4 p-4 w-100 rounded shadow-sm">
                    <div className="doctor-profile">
                      <div
                        className="skeleton w-100 rounded-circle"
                        style={{
                          width: "100px",
                          maxWidth: "100%",
                          height: "100px",
                          aspectRatio: "1/1",
                        }}
                      ></div>
                    </div>
                    <div className="doctor-details row align-items-center gap-4 flex-1 w-100">

                      <div className="doctor-details-left flex-1 w-100">
                        <div
                          className="skeleton  "
                          style={{
                            height: "30px",
                            width: "50%",
                          }}
                        />
                        <span
                          className="d-inline-block skeleton mt-3 "
                          style={{
                            height: "25px",
                            width: "70px",
                          }}
                        />{" "}
                        <span
                          className=" d-inline-block  skeleton  mt-3 "
                          style={{
                            height: "25px",
                            width: "50px",
                          }}
                        />{" "}
                        
                       
                      </div>
 
                    </div>
                  </div>
                </div>
                
              </>
            ) : (
             !loading && doctorList.length !== 0 ? doctorList.map((gym,index) => {
                const isLast = index === doctorList.length - 1;
          

  const firstOffer = gym.offers && gym.offers[0];
  const allOffers = gym.offers || [];

  return ( 

 <div
  className="col-md-6 mb-3"
  key={gym._id}
  ref={isLast ? lastCardRef : null}
>
  <div className="card border-0 shadow-sm rounded-4 bg-white h-100">
    
    {/* IMAGE + DISCOUNT BADGE */}
    <div
      className="position-relative overflow-hidden rounded-top-4"
      style={{ height: "190px" }}
    >
      <Link to={`/listing/${gym._id}`} > 
      <img
        src={
          gym?.profile
            ? weburl + gym.profile
            : "/assets/img/placeholder.png"
        }
        onError={(e) => (e.target.src = "/assets/img/placeholder.png")}
        className="w-100 h-100"
        style={{ objectFit: "cover" }}
        alt={gym.username}
      />
     </Link>

      {gym.discountPercent && (
        <span
          className="position-absolute top-0 end-0 m-2 px-2 py-1 rounded-3 small fw-semibold text-white"
          style={{ backgroundColor: "#ff6a00" }}
        >
          {gym.discountPercent}% OFF
        </span>
      )}
    </div>

    {/* CONTENT */}
    <div className="card-body pt-3 pb-2 px-3 text-dark">

    
      {/* TITLE + TAG + RATING */}
         <div>
            <Link to={`/listing/${gym._id}`} > 
          <h6 className="mb-1 fw-semibold text-truncate">{gym.username}</h6>
</Link>

<div className="d-flex align-items-center gap-2 small text-muted mb-1">
          <span className="badge rounded-pill px-2 py-1 small"
            style={{ backgroundColor: "#e7f7eb", color: "#0a8f28" }}>
            Gym
          </span>

            <div className="d-flex align-items-center gap-1">
          <i className="ri-star-fill text-warning" />
          <span className="fw-semibold small text-dark">
            {gym.rating ? gym.rating.toFixed(1) : "4.8"}
          </span>
        </div>

        </div>
 


          </div>

      {/* LOCATION */}
      <div className="d-flex align-items-center gap-2 small text-muted mb-1">
        <i className="ri-map-pin-2-line" />
        <span className="text-truncate">
          {gym.address
            ? gym.address
            : `${gym.city || ""}${gym.city && gym.statename ? ", " : ""}${
                gym.statename || ""
              }`}
        </span>
      </div>

      {/* DISTANCE */}
      <div className="d-flex align-items-center gap-2 small mb-2">
        <i className="ri-navigation-fill" style={{ color: "#21c45d" }} />
        <span style={{ color: "#21c45d" }}>
          {Math.round(gym._distanceKm ?? 0)} km
        </span>
        <span className="text-muted">away</span>
      </div>

      {/* AMENITIES */}
      {gym.subDepartments && gym.subDepartments.length > 0 && (
        <div className="d-flex flex-wrap gap-2 mb-3">
          {gym.subDepartments.slice(0, 3).map((cat, i) => (
            <span
              key={i}
              className="badge rounded-pill px-2 py-1 small"
              style={{
                backgroundColor: "#f4f4f4",
                border: "1px solid #ddd",
                color: "#555",
              }}
            >
              {cat}
            </span>
          ))}

          {gym.subDepartments.length > 3 && (
            <span
              className="badge rounded-pill px-2 py-1 small"
              style={{
                backgroundColor: "#f4f4f4",
                border: "1px solid #ddd",
                color: "#555",
              }}
            >
              +{gym.subDepartments.length - 3}
            </span>
          )}
        </div>
      )}
  {showAllOffers !== gym._id && 
   <div
  className="d-flex align-items-center justify-content-between rounded-3 px-3 py-2 mb-3"
  style={{ border: "1px solid #e6e6e6", backgroundColor: "#fafafa" }}
>

   <div className="d-flex gap-2 align-items-center">
   
    <div className="small text-muted text-decoration-line-through">
      ₹{firstOffer ? firstOffer.regularPrice : "5,999"}/
      {firstOffer ? firstOffer.regularUnit : "month"}
    </div>
     <div className="fw-semibold text-dark">
      ₹{firstOffer ? firstOffer.salePrice : "3,999"}/
      {firstOffer ? firstOffer.saleUnit : "month"}
    </div>
    {firstOffer?.extraText && (
      <div className="small d-block" style={{ color: "#21c45d" }}>
        {firstOffer.extraText}
      </div>
    )}
  </div>
 
  <i className="ri-price-tag-3-line text-warning fs-5" />
</div>

  }


{showAllOffers === gym._id && allOffers.length > 0 &&  allOffers.map((offer, index) => (

   <div key={index}

  className="d-flex align-items-center justify-content-between rounded-3 px-3 py-2 mb-3"
  style={{ border: "1px solid #e6e6e6", backgroundColor: "#fafafa" }}
>
  <div className="d-flex gap-2 align-items-center">
   
    <div className="small text-muted text-decoration-line-through">
      ₹{offer ? offer.regularPrice : "5,999"}/
      {offer ? offer.regularUnit : "month"}
    </div>
     <div className="fw-semibold text-dark">
      ₹{offer ? offer.salePrice : "3,999"}/
      {offer ? offer.saleUnit : "month"}
    </div>
    {offer?.extraText && (
      <div className="small d-block" style={{ color: "#21c45d" }}>
        {offer.extraText}
      </div>
    )}
  </div>

  <i className="ri-price-tag-3-line text-warning fs-5" />
</div>)
)}

      {/* FOOTER BUTTONS */}
      <div className="d-flex gap-2 ">
        <a
          href={gym.phone ? `tel:${gym.phone}` : "#"}
          className="btn btn-dark text-white flex-grow-1 d-flex align-items-center justify-content-center gap-2 rounded-3 py-2"
        >
          <i className="ri-phone-line" />
          <span>Call</span>
        </a>

        <button
          type="button"
          className="btn flex-grow-1 d-flex align-items-center justify-content-center gap-2 rounded-3 py-2"
          style={{ backgroundColor: "#00e676", color: "#000" }}
          onClick={() => setShowAllOffers(prev => prev === gym._id ? null : gym._id) }
>
        {showAllOffers ? "Hide Offers" : "View Offers"}
          
        </button>
      </div>
    </div>
  </div>
</div>


                
              )}) : (
              <div className='container d-flex align-items-center justify-content-center' style={{height:'50vh'}}>
                <div className='text-center'>

                <i class="ri-search-eye-line h1 fw-light text-secondary"></i>
                <h3> No users match your search</h3>
                <p> Nothing found for {(() => {
    // Find the selected state once and store it
    const selectedState = data.find(item => item._id === filterInputs.state);
    if (selectedState) {
      return `${selectedState.name} ${filterInputs.city !== null ? `, ${filterInputs.city}` :''} `; // You can format this as you need
    } else {
      return 'India'; // Fallback text if no state is found
    }
  })()}   </p>
                 </div>
                 </div>)
            )}

              </div>

 {isFetchingMore && (
  <div className="row">
    {[...Array(2)].map((_, index) => (
      <div className="doctor-card col-md-6" key={index}>
        <div className="d-flex border-bottom gap-4 p-4 w-100 rounded shadow-sm">
          <div className="doctor-profile">
            <div
              className="skeleton w-100 rounded-circle"
              style={{
                width: "100px",
                maxWidth: "100%",
                height: "100px",
                aspectRatio: "1/1",
              }}
            ></div>
          </div>
          <div className="doctor-details row align-items-center gap-4 flex-1 w-100">
            <div className="doctor-details-left flex-1 w-100">
              <div
                className="skeleton"
                style={{
                  height: "30px",
                  width: "50%",
                }}
              />
              <span
                className="d-inline-block skeleton mt-3"
                style={{
                  height: "25px",
                  width: "70px",
                }}
              />
              <span
                className="d-inline-block skeleton mt-3"
                style={{
                  height: "25px",
                  width: "50px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
)}

 
               

            </div>

</div>
  
</div>

{/* <div className='container mt-4'>
  <div className='d-flex bg-light border  align-center p-2 mx-auto overflow-hidden justify-content-between' style={{maxWidth:'500px',borderRadius:'40px'}}>
  <button href="/hospital/67973150a76a66c3198c5060" onClick={handlePreviousPage} disabled={loading || currentPage === 1} className="btn btn-white btn-shadow d-block border " style={{borderRadius:'40px'}} >Previous</button>
  <div className='col align-items-center d-flex justify-content-center'>
    <span>   Showing  {currentPage} of {totalPages} </span>
  </div>
  <button className="btn btn-white btn-shadow d-block border" style={{borderRadius:'40px'}}  onClick={handleNextPage} disabled={loading || currentPage === totalPages} >Next</button>

  </div>
</div> */}

 

            </div>


      <Footer />

    </>
  );
};

export default FindListing;
